import React from "react";




const Favorites = props => {
    return (
        <div>
            <h4>Избранное</h4>

        </div>

    )
}
export default Favorites
